<!-- <div *ngIf="true" class="flex justify-center my-10 px-5 md:px-12 lg:px-27">
    <div class="text-center text-text-primary">
        <h2 class="h2-text" i18n>Coming soon</h2>
        <p class="body-m-text my-4" i18n>Subscribe to get notified when we launch</p>
        <form [formGroup]="subscriberForm" (ngSubmit)="subscribe()">
            <mat-form-field class="w-full">
                <input matInput i18n-placeholder placeholder="Your email" formControlName="subscriberEmail"/>                
            </mat-form-field>

            <button *ngIf="!subscribedToNews" class="primary-button w-full" type="submit" i18n>Subscribe</button>
            <button *ngIf="subscribedToNews" class="base-button bg-transparent flex justify-center items-center text-accent-green w-full gap-2" type="button">
                <mat-icon>check</mat-icon>
                <span i18n>Subscribed!</span>
            </button>
        </form>
    </div>
</div> -->

<div class="flex justify-center my-10 px-5 md:px-12 lg:px-27">
    <form class="flex flex-col w-full sm:w-98" [formGroup]="userForm" (ngSubmit)="register()">
        <div class="flex items-center mb-4">
            <span class="h3-text text-text-primary text-center w-full" i18n>Register</span>
        </div>
        <div class="flex flex-col md:flex-row md:gap-4">
            <mat-form-field class="w-full md:w-48">
                <img matPrefix src="assets/icons/dark/user.svg" class="prefix-icon" alt="user icon"/>
                <input matInput i18n-placeholder placeholder="First name" formControlName="firstName"/>
                <mat-error i18n>First name is required</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full md:w-48">
                <img matPrefix src="assets/icons/dark/user.svg" class="prefix-icon" alt="user icon"/>
                <input matInput i18n-placeholder placeholder="Last name" formControlName="lastName"/>
                <mat-error i18n>Last name is required</mat-error>
            </mat-form-field>
        </div>
        <mat-form-field>
            <img matPrefix src="assets/icons/dark/mail.svg" class="prefix-icon" alt="mail icon"/>
            <input matInput i18n-placeholder placeholder="Email" [readonly]="isOAuthUser" formControlName="userName"/>
            <mat-error i18n>Email is required</mat-error>
        </mat-form-field>
        <mat-form-field>
            <img matPrefix src="assets/icons/dark/phone.svg" class="prefix-icon" alt="phone icon"/>
            <input matInput i18n-placeholder placeholder="Phone number" type="tel" formControlName="phoneNumber"/>
        </mat-form-field>
        
        <mat-form-field>
            @if(userForm.controls['countryCode'].value?.length == 2) {
                <span matPrefix class="prefix-icon fi fi-{{userForm.controls['countryCode'].value?.toLowerCase()}}"></span> 
            } 
            @else {
                <img matPrefix src="assets/icons/dark/world.svg" class="prefix-icon" alt="globe icon"/>
            }
            <input
                id="countryInput"
                type="text"
                matInput
                i18n-placeholder
                placeholder="Country"
                [matAutocomplete]="countryAuto"
                formControlName="countryCode"
                (keyup)="onCountryInputKeyUp($event)"
            />
            <mat-autocomplete #countryAuto="matAutocomplete" [displayWith]="getCountryName.bind(this)" (optionSelected)="selectCountry($event)">
                @for (country of filteredCountries$ | async; track country) {
                    <mat-option [value]="country.value">
                        <div class="flex items-center justify-start gap-2">
                            <span class="fi fi-{{country.value.toLowerCase()}}"></span>
                            {{country.label}}
                        </div>
                    </mat-option>
                }
            </mat-autocomplete>
            <mat-error *ngIf="userForm.controls['countryCode'].hasError('required')" i18n>Country is required</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="!isOAuthUser">
            <img matPrefix src="assets/icons/dark/lock.svg" class="prefix-icon" alt="lock icon"/>
            <input matInput i18n-placeholder placeholder="Password" type="{{showPassword ? 'text' : 'password'}}" formControlName="password"/>
            <img matSuffix src="{{showPassword ? 'assets/icons/dark/eye-off.svg' : 'assets/icons/dark/eye.svg'}}" class="suffix-icon" alt="eye icon" (click)="togglePasswordVisibility()"/>
            <mat-error *ngIf="userForm.controls['password'].hasError('required')" i18n>Password is required</mat-error>
            <mat-error *ngIf="userForm.controls['password'].hasError('minlength')" i18n>Password must have at least {{minPwdLength}} characters</mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="!isOAuthUser" subscriptSizing="dynamic">
            <img matPrefix src="assets/icons/dark/lock.svg" class="prefix-icon" alt="lock icon"/>
            <input matInput i18n-placeholder placeholder="Confirm password" type="{{showConfirmPassword ? 'text' : 'password'}}" formControlName="confirmPassword"/>
            <img matSuffix src="{{showConfirmPassword ? 'assets/icons/dark/eye-off.svg' : 'assets/icons/dark/eye.svg'}}" class="suffix-icon" alt="eye icon" (click)="toggleConfirmPasswordVisibility()"/>
            <mat-error *ngIf="userForm.controls['confirmPassword'].hasError('noMatch')" i18n>Passwords must match</mat-error>
        </mat-form-field>  

        <mat-checkbox class="mt-4" formControlName="age18" #age18chk i18n>I am older than 18 years</mat-checkbox>
        <span class="errorText"
            *ngIf="clickedSubmit && userForm.controls['age18'].hasError('required')"
            i18n>You must be at least 18 years old</span>
        <mat-checkbox formControlName="newsletter" i18n>I want to subscribe to newsletter</mat-checkbox>
        
        <mat-checkbox formControlName="acceptTOS" 
            i18n>I accept <a class="legalsLink" routerLink="/legal/privacy-policy">Privacy Policy</a> and <a class="legalsLink" routerLink="/legal/terms-of-service">Terms of Service</a>
        </mat-checkbox>
        <span class="errorText"
            *ngIf="clickedSubmit && userForm.controls['acceptTOS'].hasError('required')" 
            i18n>You must accept Privacy Policy and Terms of Service</span>

        <app-altcha *ngIf="!isOAuthUser" class="mt-4" formControlName="altcha"></app-altcha>
        <span class="errorText mt-2"
            *ngIf="clickedSubmit && userForm.controls['altcha'].hasError('required')"
            i18n>Please click "I'm not a robot" checkbox</span>

        <button *ngIf="!sendingRequest" class="mt-2 primary-button" type="submit" i18n="@@sign-up-action-button">Sign up</button>
        <div *ngIf="sendingRequest" class="mt-2 flex justify-center">
            <mat-spinner diameter="50">
            </mat-spinner>
        </div>
        <button class="mt-2 secondary-button-transparent" type="button" routerLink="/login" i18n="@@log-in-action-button">Log in</button>

    </form>
</div>